export type MaterialMode = 'canvas' | 'alu'

/**
 * slab = Leinwand/Alu-Platte (bestehender Pfad, byte-identisch), shaped-slab = Platte in Produktform
 * (rund/hexagon/abgerundet, aus der Size-Geometrie), mug = Tasse mit Druckband, flat = flache Karte.
 * `slab` wechselt automatisch auf `shaped-slab`, wenn die Geometrie keine Rechteckform ist.
 */
export type PreviewKind = 'slab' | 'shaped-slab' | 'mug' | 'flat'

export type Vec3 = { x: number; y: number; z: number }

export type Preview3DConfig = {
  wrapDepth: number
  barWidth: number
  barDepth: number
  stapleStep: number
  stretcherDepth: number
  wrapBackExtra: number
  canvasFrontThick: number
  aluDepth: number
  roundedRadius: number
  roundedSegments: number
  zoomStep: number
  roomCamera: Vec3
  studioCamera: Vec3
  studioPlaneScale: number
  studioStartRotationDeg: Vec3
  defaultMaterialMode: MaterialMode
  defaultShowFrame: boolean
  previewKind: PreviewKind
  /** Tasse: Radius/Höhe in Welt-Einheiten relativ zur Szene, Druckband in Grad um den Umfang */
  mugRadius: number
  mugHeight: number
  mugWrapDeg: number
}

export const DEFAULT_PREVIEW_3D_CONFIG: Preview3DConfig = {
  wrapDepth: 0.02,
  barWidth: 0.045,
  barDepth: 0.025,
  stapleStep: 0.18,
  stretcherDepth: 0.025,
  wrapBackExtra: 0.012,
  canvasFrontThick: 0.01,
  aluDepth: 0.008,
  roundedRadius: 0.006,
  roundedSegments: 6,
  zoomStep: 0.5,
  roomCamera: { x: 0, y: 0, z: 5 },
  studioCamera: { x: 3, y: 2, z: 5 },
  studioPlaneScale: 1.2,
  studioStartRotationDeg: { x: -5, y: 10, z: 0 },
  defaultMaterialMode: 'canvas',
  defaultShowFrame: true,
  previewKind: 'slab',
  mugRadius: 0.42,
  mugHeight: 1.0,
  mugWrapDeg: 300,
}

